/**
 * Money from the API is in tiyin (1 sum = 100 tiyin, company API standard). The storefront shows whole sums:
 * "5 990 000" (groups split by a narrow no-break space, so a price never wraps in the middle). Locale-independent
 * on purpose: Intl has no reliable `uz` data, and both languages group digits the same way.
 */
export function formatSum(tiyin: number): string {
  return groupDigits(Math.round(tiyin / 100));
}

/** Whole sums the customer edits (filters), grouped like prices: "1 500 000". */
export function groupDigits(sum: number): string {
  return Math.round(sum)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, "\u202F");
}

/** Tiyin from the API → whole sums, for inputs and sliders the customer edits in sums. */
export function toSum(tiyin: number): number {
  return Math.round(tiyin / 100);
}

/** Whole sums the customer typed → tiyin for the API. */
export function toTiyin(sum: number): number {
  return Math.round(sum * 100);
}
